
export default class FiltersBox {
  constructor($el) {
    this.$parentSelect = $el.querySelector('select[data-filters-box-parent]');
    this.$childSelect = $el.querySelector('select[data-filters-box-child]');
    this.$submit = $el.querySelector('button[data-filters-box-submit]'); // not required

    this.data = JSON.parse($el.getAttribute('data-filters-box'));

    this.createChildOptions();

    this.onParentValueChange(this.$parentSelect.value);
    this.bindEvents();
  }

  createChildOptions() {
    this.childOptions = this.data.child.map(({
      value, label, icon,
    }) => FiltersBox.createOptionObj(value, label, { icon }));

    const $firstOption = this.$childSelect.querySelector('option');
    if ($firstOption !== null) {
      this.childOptions.unshift(FiltersBox.createOptionObj('', $firstOption.innerText, {
        disabled: $firstOption.getAttribute('disabled'),
        selected: $firstOption.getAttribute('selected'),
      }));
    }

    this.$childSelect.innerHTML = '';
    this.$childStash = document.createDocumentFragment();
  }

  static createOptionObj(value, label = null, {
    icon = null,
    disabled = null,
    selected = null,
  } = {}) {
    const $option = document.createElement('option');
    $option.value = value;
    $option.innerText = label !== null ? label : value;
    if (icon !== null) $option.setAttribute('data-icon', icon);
    if (disabled !== null) $option.setAttribute('disabled', disabled);
    if (selected !== null) $option.setAttribute('selected', selected);

    return {
      value,
      label,
      $option,
    };
  }

  bindEvents() {
    this.$parentSelect.addEventListener('change', this.onParentChange.bind(this));
    this.$childSelect.addEventListener('change', this.onChildChange.bind(this));
  }

  onParentChange(e) {
    this.onParentValueChange(e.target.value);
  }

  onParentValueChange(value) {
    const selectedOptionObj = this.data.parent.find(optionObj => optionObj.value === value);

    const isChildActive = selectedOptionObj !== undefined;

    FiltersBox.setDisabled(this.$childSelect, !isChildActive);
    this.updateChildOptions(isChildActive ? selectedOptionObj.options : []);

    this.updateSubmitStatus();
  }

  onChildChange() {
    this.updateSubmitStatus();
  }

  updateSubmitStatus() {
    const { $submit, $parentSelect, $childSelect } = this;
    if ($submit === null) return;

    const mode = $submit.getAttribute('data-filters-box-submit') || 'all';
    let isSubmitActive = false;

    switch (mode) {
      case 'any':
        isSubmitActive = ($parentSelect.value !== '' || $childSelect.value !== '');
        break;

      case 'all':
      default:
        isSubmitActive = !($parentSelect.value === '' || $childSelect.value === '');
        break;
    }

    FiltersBox.setDisabled($submit, !isSubmitActive);
  }

  updateChildOptions(options) {
    this.$childSelect.value = '';

    const requiredOptions = ['', ...options]; // add empty option as first
    this.childOptions.forEach(({ value, $option }) => {
      if (requiredOptions.includes(value)) {
        this.$childSelect.appendChild($option);
      } else {
        // this.$childSelect.removeChild($option); // requires to check option is current  child
        this.$childStash.appendChild($option); // instead of removeChild
      }
    });
  }

  static setDisabled($el, disabled) {
    if (disabled) {
      $el.setAttribute('disabled', 'disabled');
    } else {
      $el.removeAttribute('disabled');
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-filters-box').forEach(
    $filtersBox => new FiltersBox($filtersBox),
  );
});
